import { useMediaAiTrainingDataApi } from '@/common/api/modules/mediaAiTrainingData'
import { mediaAiTrainingDataPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import ArticleHtmlForm from '@/components/container/form/modules/media/aiTrainingData/ArticleHtmlForm'

const MediaAiTrainingDataArticleHtmlPage = () => {
  const siteId = useSiteId()
  const { data, error, mutate } = useMediaAiTrainingDataApi({ site_id: siteId })

  return (
    <Main type={MainLayoutType.SMALL} bottomSpace>
      <BackButton link={mediaAiTrainingDataPath(siteId)} />
      <DetailPageLoader error={error} data={data}>
        {data && <ArticleHtmlForm data={data} onRefetch={mutate} />}
      </DetailPageLoader>
    </Main>
  )
}

export default MediaAiTrainingDataArticleHtmlPage
